<template>
  <div>
    <app-spinner v-if="!is_loaded"/>
    <template v-else>
      <h1 class="title">Warnings</h1>
      <app-cells>
        <app-button @click.native="showModal(null)">Issue Warning</app-button>
      </app-cells>
      <app-cells><h2 class="title">Requested</h2></app-cells>
      <table-request
        @showModal="showModal"
        @clickPagination="onClickPaginationRequest"
        :tableItems="table_request_items"
        :pagination="pagination_request"
        :tablePreloader="table_request_preloader"
        :getUserAvatar="getUserAvatar"
        :formatDateTime="formatDateTime"
      />
      <app-cells><h2 class="title">Signed</h2></app-cells>
      <table-signed
        @clickPagination="onClickPaginationSigned"
        :tableItems="table_signed_items"
        :pagination="pagination_signed"
        :tablePreloader="table_signed_preloader"
        :getUserAvatar="getUserAvatar"
        :formatDateTime="formatDateTime"
      />
      <template v-if="table_rejected_items.length">
        <app-cells><h2 class="title">Rejected</h2></app-cells>
        <table-rejected
          @clickPagination="onClickPaginationRejected"
          :tableItems="table_rejected_items"
          :pagination="pagination_rejected"
          :tablePreloader="table_rejected_preloader"
          :getUserAvatar="getUserAvatar"
          :formatDateTime="formatDateTime"
        />
      </template>
      <template v-if="table_cancelled_items.length">
        <app-cells><h2 class="title">Cancelled</h2></app-cells>
        <table-cancelled
          @clickPagination="onClickPaginationCancelled"
          :tableItems="table_cancelled_items"
          :pagination="pagination_cancelled"
          :tablePreloader="table_cancelled_preloader"
          :getUserAvatar="getUserAvatar"
          :formatDateTime="formatDateTime"
        />
      </template>
    </template>
    <modal
      name="create-request"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('create-request')" class="popup__close" type="button"></button>
        <div class="popup__title">{{ warning_to_action ? 'Update' : 'Issue' }} Warning</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Status" required>
              <app-cells :indent="false">
                <app-radio
                  v-for="radio of status_options"
                  :key="radio.label"
                  v-model="form.status"
                  :value="radio.value"
                  name="status"
                  :checked="form.status === radio.value"
                >
                  <template #label>{{ radio.label }}</template>
                </app-radio>
              </app-cells>
              <template #error>
                <div v-if="$v.form.status.$dirty && !$v.form.status.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group
              v-if="form.status === 'requested' || form.status === 'signed'"
              label="Apply in Payroll"
              required
            >
              <app-date-picker
                v-model="form.related_month"
                format="MMM YYYY"
                type="month"
                placeholder="Apply in Payroll"
                :error="$v.form.related_month.$error"
              />
              <template #error>
                <div v-if="$v.form.related_month.$dirty && !$v.form.related_month.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group v-if="!warning_to_action" label="Employee" required>
              <app-select
                @search="onEmployeeSearch"
                v-model="form.employee"
                :options="employees_options"
                :clearable="false"
                label="full_name"
                placeholder="Employee"
                :error="$v.form.employee.$error"
              />
              <template #error>
                <div v-if="$v.form.employee.$dirty && !$v.form.employee.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group
              v-if="form.status === 'requested' || form.status === 'signed'"
              label="Penalty (TZS)"
              label-for="penalty"
              required
            >
              <app-fin-number
                v-model="form.penalty"
                id="penalty"
                placeholder="Penalty (TZS)"
                :error="$v.form.penalty.$error"
              />
              <template #error>
                <div v-if="$v.form.penalty.$dirty && !$v.form.penalty.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group
              v-if="form.status === 'requested' || form.status === 'signed'"
              label="Reason"
              label-for="reason"
              required
            >
              <app-textarea
                v-model="form.reason"
                id="reason"
                placeholder="Reason"
                :error="$v.form.reason.$error"
              />
              <template #error>
                <div v-if="$v.form.reason.$dirty && !$v.form.reason.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group v-if="form.status === 'signed'" label="Attachment" required>
              <app-uploader
                v-model="form.scancopy"
                :extensions="['application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
                class="custom-uploader--flex"
              />
              <template #error>
                <div v-if="$v.form.scancopy.$dirty && !$v.form.scancopy.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="submit_request">Save</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>

import { getEmployeesListSearch, getEmployeesWarningList, patchEmployeesWarning, postEmployeesWarning } from '@/http'
import { required, requiredIf } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'
import { format, parseISO } from 'date-fns'
import TableRequest from '@/views/employees/warnings/tables/TableRequest'
import TableSigned from '@/views/employees/warnings/tables/TableSigned'
import TableRejected from '@/views/employees/warnings/tables/TableRejected'
import TableCancelled from '@/views/employees/warnings/tables/TableCancelled'

export default {
  name: 'EmployeesWarningsRequested',
  components: {TableRequest, TableSigned, TableRejected, TableCancelled},
  data() {
    return {
      is_loaded: false,
      form: {},
      employees_options: [],
      warning_to_action: null,
      table_request_items: [],
      pagination_request: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_request_preloader: false,
      table_signed_items: [],
      pagination_signed: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_signed_preloader: false,
      table_rejected_items: [],
      pagination_rejected: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_rejected_preloader: false,
      table_cancelled_items: [],
      pagination_cancelled: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_cancelled_preloader: false,
    }
  },
  created() {
    Promise.all([
      this.fetchItemsRequested(),
      this.fetchItemsSigned(),
      this.fetchItemsRejected(),
      this.fetchItemsCancelled()
    ])
      .then(() => {
        this.is_loaded = true
      })
  },
  computed: {
    status_options() {
      return this.warning_to_action ? [
        {value: 'requested', label: 'Requested'},
        {value: 'signed', label: 'Signed'},
        {value: 'rejected', label: 'Rejected'},
        {value: 'cancelled', label: 'Cancelled'},
      ] : [
        {value: 'requested', label: 'Requested'},
        {value: 'signed', label: 'Signed'},
      ]
    },
  },
  validations: {
    form: {
      employee: {
        required: requiredIf(function () {
          return !this.warning_to_action
        })
      },
      reason: {
        required: requiredIf(function () {
          return this.form.status === 'signed' || this.form.status === 'requested'
        })
      },
      penalty: {
        required: requiredIf(function () {
          return this.form.status === 'signed' || this.form.status === 'requested'
        })
      },
      status: {required},
      related_month: {
        required: requiredIf(function () {
          return this.form.status === 'signed' || this.form.status === 'requested'
        })
      },
      scancopy: {
        required: requiredIf(function () {
          return this.form.status === 'signed'
        })
      },
    }
  },
  methods: {
    async fetchItemsRequested() {
      this.table_request_preloader = true
      const response = await getEmployeesWarningList({
        page: this.pagination_request.page,
        page_size: 20,
        status: 'requested'
      })
      this.table_request_items = response.data.results
      this.pagination_request.pages = response.data.pages
      this.pagination_request.count = response.data.count
      this.table_request_preloader = false
    },
    async fetchItemsSigned() {
      this.table_signed_preloader = true
      const response = await getEmployeesWarningList({
        page: this.pagination_signed.page,
        page_size: 20,
        status: 'signed'
      })
      this.table_signed_items = response.data.results
      this.pagination_signed.pages = response.data.pages
      this.pagination_signed.count = response.data.count
      this.table_signed_preloader = false
    },
    async fetchItemsRejected() {
      this.table_rejected_preloader = true
      const response = await getEmployeesWarningList({
        page: this.pagination_rejected.page,
        page_size: 20,
        status: 'rejected'
      })
      this.table_rejected_items = response.data.results
      this.pagination_rejected.pages = response.data.pages
      this.pagination_rejected.count = response.data.count
      this.table_rejected_preloader = false
    },
    async fetchItemsCancelled() {
      this.table_cancelled_preloader = true
      const response = await getEmployeesWarningList({
        page: this.pagination_cancelled.page,
        page_size: 20,
        status: 'cancelled'
      })
      this.table_cancelled_items = response.data.results
      this.pagination_cancelled.pages = response.data.pages
      this.pagination_cancelled.count = response.data.count
      this.table_cancelled_preloader = false
    },
    fetchTables() {
      this.fetchItemsRequested()
      this.fetchItemsSigned()
      this.fetchItemsRejected()
      this.fetchItemsCancelled()
    },
    onClickPaginationRequest(page) {
      this.pagination_request.page = page
      this.fetchItemsRequested()
    },
    onClickPaginationSigned(page) {
      this.pagination_signed.page = page
      this.fetchItemsSigned()
    },
    onClickPaginationRejected(page) {
      this.pagination_rejected.page = page
      this.fetchItemsRejected()
    },
    onClickPaginationCancelled(page) {
      this.pagination_cancelled.page = page
      this.fetchItemsCancelled()
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit_request.preload = true
      if (this.warning_to_action) {
        patchEmployeesWarning(this.warning_to_action, this.normalizeForm())
          .finally(() => {
            this.$refs.submit_request.preload = false
          })
          .then(() => {
            this.fetchTables()
            this.$notify({
              type: 'success',
              title: 'Data saved',
            })
            this.$modal.hide('create-request')
          })
      } else {
        postEmployeesWarning(this.normalizeForm())
          .finally(() => {
            this.$refs.submit_request.preload = false
          })
          .then(() => {
            this.fetchItemsRequested()
            this.fetchItemsSigned()
            this.$notify({
              type: 'success',
              title: 'Warning created',
            })
            this.$modal.hide('create-request')
          })
      }
    },
    normalizeForm() {
      const normalizedForm = {...this.form}
      if (normalizedForm.status === 'rejected' || normalizedForm.status === 'cancelled') {
        delete normalizedForm.penalty
        delete normalizedForm.reason
        delete normalizedForm.scancopy
        delete normalizedForm.related_month
      }
      if (normalizedForm.employee) normalizedForm.employee = normalizedForm.employee.id
      if (normalizedForm.scancopy) normalizedForm.scancopy = normalizedForm.scancopy.id
      return normalizedForm
    },
    showModal(row) {
      this.warning_to_action = row?.id
      if (row) {
        this.form = {
          status: row.status.code,
          reason: row.reason,
          scancopy: row.scancopy,
          penalty: row.penalty,
          related_month: row.related_month,
        }
      } else {
        this.form = {
          status: 'requested',
        }
      }
      this.$v.form.$reset()
      this.$modal.show('create-request')
    },
    onEmployeeSearch(search, loading) {
      loading(true)
      this.searchEmployee(loading, search, this)
    },
    searchEmployee: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.employees_options = []
      } else {
        getEmployeesListSearch({search, employment_status: 'working'}).then(response => {
          loading(false)
          vm.employees_options = response.data
        })
      }
    }, 350),
    formatDateTime(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMMM yyyy HH:mm')
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
